export default __webpack_public_path__ + "static/media/avatar_lion6.5a33762a.mp3";